module.exports = __webpack_public_path__ + "img/HSR-1-Head-Template-Replicator.a6f64af3.jpg";